import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth.service';
 
/**
 * Declaración global de la función `gtag` expuesta por Google Analytics.
 * Se asume que el snippet de GA4 ya fue cargado en `index.html`.
 */
declare var gtag: Function;
 
/**
 * Tipado base flexible y extensible para los parámetros de eventos.
 * Permite enviar cualquier estructura de datos sin imponer un esquema fijo.
 */
export type GAEventParams = {
  [key: string]: any;
};
 
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
 
  /**
   * Constructor del servicio.
   * Inicializa Google Analytics al momento de cargar la aplicación.
   * El servicio se instancia una sola vez gracias al scope `root`.
   */
  constructor() {
    this.initGA();
  }
 
  /**
   * Inicializa Google Analytics 4 usando el Measurement ID configurado
   * en los archivos de entorno.
   *
   * - Evita la inicialización si el Measurement ID no está definido.
   * - Desactiva el envío automático de `page_view` para SPAs.
   * - Activa `debug_mode` solo si el entorno lo indica.
   */
  private initGA() {
    const id = environment.ga_measurement_id_intermediarios;
 
    if (!id) {
      console.warn('[GoogleAnalyticsService] GA Measurement ID no definido');
      return;
    }
 
    // Marca el momento de inicialización de GA
    gtag('js', new Date());
 
    // Configura GA4 y desactiva page_view automático para SPA
    gtag('config', id, {
      send_page_view: false,
      ...(environment.ga_debug_mode_intermediarios && { debug_mode: true })
    });
  }
 
  /**
   * Envía manualmente un evento `page_view`.
   * Debe ejecutarse cuando Angular cambia de ruta
   * (por ejemplo, en Router NavigationEnd).
   *
   * @param path Ruta actual de la aplicación (ej: '/dashboard')
   * @param params Parámetros adicionales opcionales para el page view
   */
  trackPageView(path: string, params: GAEventParams = {}) {
    gtag('event', 'page_view', {
      page_path: path,
      ...params,
    });
  }
 
  /**
   * Envía un evento personalizado a Google Analytics.
   *
   * El nombre del evento debe cumplir las reglas de GA4:
   * - minúsculas
   * - sin espacios
   * - usar snake_case
   *
   * @param eventName Nombre del evento (ej: 'open_modal')
   * @param params Objeto de parámetros completamente libre y extensible
   */
  trackEvent(eventName: string, params: GAEventParams = {}) {

    const eventParams = {
    intermediario: localStorage.getItem('producerName'),
    ...params 
  };



    gtag('event', eventName, eventParams);
  }
}